import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const CustomLink = styled('a')(({ theme }) => ({
  display: 'block',
  textDecoration: 'none',

  '&:not(:last-child)': {
    marginBottom: theme.spacing(4),
  },
}));

export const BankCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing(6),
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.cream100.main}`,
  borderRadius: theme.spacing(8),
  boxShadow: 'inset 0 0 0 2px transparent',
  transition: '.25s',

  '&:hover': {
    boxShadow: `inset 0 0 0 2px ${theme.palette.blue400.main}`,
  },

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4),
  },
}));

export const BankDetails = styled('div')({
  width: '100%',
});

export const BankName = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const DetailsContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
}));

export const DetailItem = styled('div')({
  width: '100%',
});

export const Header = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));

export const DepositAmount = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const TooltipContent = styled('div')(({ theme }) => ({
  display: 'inline-block',
  marginLeft: theme.spacing(1),
}));

export const FontWeightMedium = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.subtitle1.fontWeight,
}));

export const BenefitsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginTop: theme.spacing(6),

  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(4),
  },
}));
